import ENV from './Environment';
import Requests from './Requests';
import TokenService from './TokenService';

const baseUrl = `${ENV.base_url}/api/v1/preview/html5/manual`;

const upload = async (userData, file) => {
  const body = new FormData();
  body.append('file', file);
  const send = () => fetch(baseUrl, {
    method: 'POST',
    headers: { Authorization: `Bearer ${userData.jwtToken}` },
    body
  });

  let response = await send();
  if (response.status === 403 && await TokenService.refreshToken(userData)) {
    response = await send();
  }
  if (!response.ok) {
    throw new Error('Unable to upload the ZIP file. Please try again.');
  }
  return response.json();
};

const deletePreview = async (userData, guid) => {
  const response = await Requests.deleteRequest(`${baseUrl}/${encodeURIComponent(guid)}`, userData);
  // The delete endpoint may return 204 with no JSON body.
  if (!response || (!response.ok && response.status !== 404)) {
    throw new Error('Unable to delete the uploaded preview.');
  }
};

const ManualPreviewService = { upload, deletePreview };
export default ManualPreviewService;
